<template>
  <div>
    <main>
      <div class="w ">
        <div class="itmain">
          <div class="sort2">
            <ul
              v-infinite-scroll="load"
              infinite-scroll-disabled="disabled"
            >
              <li v-for="items in news.newcase" :key="items.id">
                <router-link to="" tag="a" @click.native="itemnews(items.id)">
                  <!-- <div class="img_div">
                    <img :src="items.img" alt class="img"/>
                  </div> -->

                   <div class="time_main fl">
                     <p class="time_top ">{{items.time_top}}</p>
                     <p class="time_bottom ">{{items.time_bottom}}</p>
                  </div>
                  <div class="new_main">
                    <div class="new_main_top">
                      <p class="title f18" v-html="items.title"></p>
                      <p class="p2">{{items.intro}}</p>
                    </div>
                  </div>
                  <div class="go_xq">
                      <img src="@/assets/images/for.png"/>
                  </div>
                </router-link>
              </li>
            </ul>
            <p v-if="loading" class="center loding"><i class="el-icon-loading"></i> 加载中...</p>
            <p v-if="noMore" class="center loding">没有更多了</p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        kind: 1,
        clickindex: 1,
        loading: false,
        news: {
          newmenu: [],
          newcase: []
        },
        sum: '',
        page:4
      };
    },
    methods: {
      load() {
        this.loading = true
        setTimeout(async () => {
          var dt = await this.$axios.post('/api/newmore', {
            menu: this.clickindex,
            amount: 3,
            page: parseInt(this.page) + 1
          })
          dt.data = JSON.parse(dt.data)
          console.log(dt)
          if (dt.status == 200) {
            if (dt.data.code !== 0) {
              this.$message({
                type: 'info',
                message: dt.data.msg
              });
              return;
            }
          } else {
            alert(dt.statusText)
            return;
          }

          dt.data.data.data.map(item =>{
            var a = item.create_time.split('-')
            item.time_top = a[2]
            item.time_bottom = a[0] + "-" + a[1]
          })

          for (var i = 0; i < dt.data.data.data.length; i++) {
            this.news.newcase.push(dt.data.data.data[i])
          }
          this.page = dt.data.data.page
          // console.log(this.news.newcase.length,this.sum)
          this.loading = false
        }, 1000)
      },
      //新闻详情页
      itemnews(val) {
        this.$router.push({
          name: 'news', params: {
            id: val + '.html',
          }
        })
      },
      //初始化数据
      async getnewlist() {
        var dt = await this.$axios.get('/api/itemnews')
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        dt.data.data.newcontent.map(item =>{
          var a = item.create_time.split('-')
          item.time_top = a[2]
          item.time_bottom = a[0] + "-" + a[1]
        })
        this.news.newmenu = dt.data.data.newmenu
        this.news.newcase = dt.data.data.newcontent
        this.sum = dt.data.data.sum
        this.clickindex = dt.data.data.newmenu[0].id
      },
    },
    computed: {
      noMore() {
        return this.news.newcase.length >= this.sum
      },
      disabled() {
        return this.loading || this.noMore
      }
    },
    created() {
      this.getnewlist()
    }
  };
</script>

<style lang="less" scoped>
  main {

    background: #f1f1f1;

    .loding {
      font-size: 14px;
      color: #666;
      padding-top:30px
    }

    .itmain {
      overflow: hidden;
      box-sizing: border-box;
      padding: 30px 75px;
      margin: 80px auto 80px;
      background: #fff;
      box-shadow: 0 2px 35px 0 #c9c9c9;

      .intro {
        text-indent: 2em;
        padding: 10px 1%;
        line-height: 30px;
        color: #6d7276;
        font-size: 16px;
      }

      .lm_title {
        padding: 0 1%;
        font-size: 35px;
        color: #323232;
        text-align: left;
        font-weight: normal;
        margin-top: 30px;
        position: relative;
        padding-bottom: 40px;
      }


      .lm_title:after {
        content: "";
        display: block;
        width: 70px;
        height: 4px;
        background: #e50012;
        position: absolute;
        left: 1%;
        margin: 12px 0 20px 0;
      }


      .menu {
        padding: 40px 1%;

        ul {
          display: flex;
          justify-content: space-around;
        }

        .menu1 {
          border-radius: 4px;
          display: inline-block;
          line-height: 40px;
          padding: 0 44px;
          font-size: 16px;
          margin: 1px;
          background: #e6e6e6;
          transition: all 0.5s ease 0s;
          font-size: 14px;

        }

        .menu1:hover {
          cursor: pointer;
          background: #e50012;
          color: #fff;
        }

        .active {
          background: #e50012;
          color: #fff;
        }
      }


      .sort2 {
        width: 100%;

          li:hover {
            .new_main .new_main_top .title{
                  color: #e50012;
              }
          }

        li {
          display: block;
          overflow: hidden;

          a {
            overflow: hidden;
            display: block;
            border-bottom: 1px solid #eee;
            padding:5px 0;

            .fl {
              img {
                width: 100%;
              }
            }
          }

          .time_main{
            background: rgba(204, 204, 204, 0.2);
            width:100px;
            padding: 24px 0;
            text-align: center;
            color: #626971;
            margin:30px  40px 30px 0;
              .time_top{
                font-weight: bold;
                font-size:26px;
              }
          }

          .img_div {
            height: 160px;
            overflow: hidden;
            float: left;
            width: 25%;
            margin-right: 2%;

            img {
              width: 100%;
            }
          }

          .go_xq {
            display: flex;
            float: right;
            align-items:center;
            width: auto;
            height: 160px;
            align-self: center;

            img {
              height: 25px;
            }
          }

          .new_main {
            float: left;
            width: 75%;

            div {
              line-height: 30px;
              overflow: hidden;

              .about {
                padding-top: 10px;
                color: #6d7276;
              }
            }

            .new_main_top {
              font-size: 16px;
              color: #111;
              padding: 24px 0;

              .title {
                margin-bottom:10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-top:22px;
              }

              .p2 {
                font-size: 16px;
                color: #999;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
            }
          }


        }
      }
    }
  }

  .block {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/itemnews.vue